<template>
  <div class="about text-xs-center">
    <v-dialog
      v-model="dialog"
      persistent
      width="600"
    >     
      <v-card>
        <v-card-title
          class="px-4 headline grey lighten-2"
          primary-title
        >
          Feedback
        </v-card-title>

        <v-card-text>
            <div class="mx-4 aboutus">
              
              <p class="mt-4 "><strong>Interactive Floorplans</strong> is a service of the University of Arizona brought to you by University Information Technology Services </p>

              <p class=""> Please let us know of any bugs, undesired/confusing behaviour, feature requests or other suggestions.</p>
               <v-form ref="form">
                    <v-text-field
                            class="mt-5"
                            v-model="email"
                            outline
                            :rules="emailRules"
                            label="Your E-mail"
                            required>
                    </v-text-field>
                                        
                    <v-textarea
                        v-model="feedback"
                        outline
                        label="Feedback">
                    </v-textarea>
                
                    <v-btn class="mx-0" small @click="submitFeedback">Submit</v-btn>                    
              
                    <v-alert type="success" :value="showSuccess">
                        Feedback sent.
                    </v-alert>
                    
               </v-form>
                </p>
              </p>
             
              <v-divider></v-divider>

            </div>
        </v-card-text>

        

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="clickOK"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

  export default {
    data () {
      return {
        dialog: true,
        email: '',
        feedback: '',
        result: '',
        showSuccess: false,
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ]
      }
    },
    methods: {
      clickOK () {
        this.$router.go('-1')
        this.dialog = false
      },
      submitFeedback () {
        console.log("Submitting feedback")
        const apiEsriToken = jscookie.get(AUTH_API_COOKIE)

        console.log(JSON.stringify({from : this.email, feedback : this.feedback}))
        let payload = {}
        payload.from = this.email
        payload.feedback = this.feedback
               
         fetch("https://api.ba.arizona.edu/if/email/iffeedback" ,
          {
            headers: {      
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                            'Accept':'application/json'
                            },
            method: "POST",            
            body: JSON.stringify(payload)
          })
        .then(response => {   
                  if (response.status == 200) {
                    response.json().then((text) => { 
                      console.log("Text: ", text) 
                      this.showSuccess = true
                      
                      //Need to put a form in and reset it, like below.
                      this.$refs.form.reset()
                      
                  })  
                } 
                else { 
                  if (response.status == 401) { resolve ("Must be logged in to send feedback.")   }
                  else            { resolve ("Error")                 }
                }
        })
      }
    }
  }
</script>

<style>

.about {
  z-index: 2;
}

.aboutPDClogo {
  margin-top: 20px;
  margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Feedback.vue